import { ReactNode } from "react";
import { FEATURES } from "../../hooks/usePermissions/permissions";
import usePermissions from "../../hooks/usePermissions";
import { Navigate } from "react-router";

interface FeatureProtectedRouteProps {
  children: ReactNode;
  feature: FEATURES | null;
}

export default function FeatureProtectedRoute({
  children,
  feature,
}: FeatureProtectedRouteProps) {
  const { can } = usePermissions();

  if (feature && !can(feature)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
